import React from 'react';
import Rest from '../../Server/Rest';
import config from '../../settings/config';
import GroupListAutorization from './GroupListAutorization';
import TableCountInfo from './../others/TableCountInfo';
import TablePagination from './../others/TablePagination';
import Spinner from '../others/Spinner';
import _ from 'underscore';
import GroupPaymentForm from './GroupPaymentForm';
import textUtils from '../../utilities/format-string';
import Popover from './../others/Popover';
import { jsPDF } from 'jspdf';
import user from '../../settings/user';
import './../../styles/css/group.css';
import GroupListPaymentFilter from './GroupListPaymentFilter';
import Parse from 'parse';
import $ from 'jquery';
import RequisitionModel from '../../models/RequisitionModel';
import SyncLoader from 'react-spinners/SyncLoader';
import { NavLink } from 'react-router-dom';
import formatString from '../../utilities/format-string';
import {
  H_BALANCE,
  H_BRANCH_OFFICE,
  H_CURRENT_PAYMENT,
  H_DISBURSEMENT,
  H_END_DATE,
  H_GROUP,
  H_INDEX,
  H_PAYMENT_AMOUNT,
  H_PROMOTER,
} from '../../constants/headersXlsx';
import { fetchPagosRealizados } from '../../services/apis/apiPayment';
import {
  fetchBigLotTotals,
  fetchSolicitudes,
} from '../../services/apis/apiCredit';
import { fetchXLS } from '../../services/apis/apiXLS';
import { buildExcelReport } from '../../utilities/ExcelReportBuilder';

// --- Funciones utilitarias ---

export const formatMoney = (value) => {
  if (value === null || value === undefined || isNaN(Number(value))) {
    return formatString.setLegiblePrice(0);
  }
  return formatString.setLegiblePrice(Number(value));
};

const getPromotorFullName = (solicitud) => {
  const promotor = solicitud.promotor;
  return `${promotor.nombre} ${promotor.apellido_paterno} ${promotor.apellido_materno}`;
};

const getTotalAuthorizedAmount = (solicitud) => {
  return solicitud.montos.reduce(
    (acc, monto) => acc + monto.monto_autorizado,
    0
  );
};

const sumCollectionByKey = (collection, key) => {
  return _.reduce(collection, (sum, item) => sum + (item[key] || 0), 0);
};

const sumCollectionBalanceDue = (collection) => {
  return _.reduce(collection, (sum, item) => sum + (item.saldo || 0), 0);
};

const wasPaymentMade = (requisition, montoPago, dateStart, dateEnd) => {
  let totalPagado = 0.0;

  if (_.isEmpty(requisition.PagosRealizados)) return false;

  requisition.PagosRealizados.forEach((pago) => {
    totalPagado += pago.monto_pagado;
  });

  totalPagado = parseFloat(totalPagado.toFixed(2));
  montoPago = parseFloat(montoPago.toFixed(2));

  const pagosRealizados = Math.floor(totalPagado / montoPago);
  const pago = _.findWhere(requisition.Pagos, { numero_pago: pagosRealizados });
  let fechaPago = pago ? pago.fecha_pago : null;

  if (!fechaPago || (!dateStart && !dateEnd)) return false;

  let fechaPagoMs = new Date(fechaPago.iso);
  fechaPagoMs.setHours(23, 59, 59, 0);
  fechaPagoMs = fechaPagoMs.getTime();

  const startMs = dateStart ? new Date(dateStart).getTime() : null;
  const endMs = dateEnd ? new Date(dateEnd).getTime() : null;

  if (endMs && endMs <= fechaPagoMs) return true;
  if (startMs && startMs <= fechaPagoMs) return true;

  return false;
};

// --- Clase principal ---

class GroupListPayment extends GroupListAutorization {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleFilter = this.handleFilter.bind(this);
    this.ref = React.createRef();
  }

  state = {
    loading: false,
    nombre: '',
    promotor: '',
    dateStart: null,
    dateEnd: null,
    Sucursal: !_.isEmpty(Parse.User.current().toJSON().Sucursal)
      ? Parse.User.current().toJSON().Sucursal.objectId
      : '',
    includeDowns: false,
    fintrar_por_fecha_finalizacion: false,
    total: 0,
    collection: [],
    requisitionSelected: {},
    requisitionPrint: false,
    monto_desembolsado_total: 0.0,
    monto_pago_total: 0.0,
    monto_pagado_total: 0.0,
    balanceDue_total: 0.0,
    loadSumary: false,
    where: {},
  };

  collection = [];
  limit = 50;
  title = 'Pagos grupales';
  order = 'updatedAt,-ciclo';
  include =
    'Grupo,Grupo.Socios,Sucursal,promotor,montos,montos.Socio,Pagos,Pagos.Socio,PagosRealizados,PagosRealizados.registrado_por';

  setWhere = (data = {}) => {
    const whereFechaPago = {
      where: { fecha_pago: {} },
      className: 'SolicitudesPagos',
    };

    if (data.dateStart) whereFechaPago.where.fecha_pago.$gte = data.dateStart;
    if (data.dateEnd) whereFechaPago.where.fecha_pago.$lte = data.dateEnd;

    const configUser = user.config();
    const filterFrom =
      configUser && configUser.filter_from
        ? { $gte: { __type: 'Date', iso: configUser.filter_from } }
        : undefined;

    let promotor = undefined;

    if (
      user.rol.permisos.filtros &&
      user.rol.permisos.filtros.es_promotor === true
    ) {
      const currentUser = Parse.User.current();
      promotor = {
        $select: {
          query: {
            where: {
              User: {
                __type: 'Pointer',
                className: '_User',
                objectId: currentUser.id,
              },
            },
            className: 'Empleados',
          },
          key: 'objectId',
        },
      };
    }

    if (!_.isEmpty(data.promotor)) promotor = data.promotor;

    let where = {
      status: data.includeDowns === false ? { $ne: 'baja' } : undefined,
      Grupo:
        !_.isEmpty(data.id_busqueda) || !_.isEmpty(data.Sucursal)
          ? {
              $inQuery: {
                where: {
                  id_busqueda: !_.isEmpty(data.id_busqueda)
                    ? data.id_busqueda
                    : undefined,
                  Sucursal: !_.isEmpty(data.Sucursal)
                    ? data.Sucursal
                    : undefined,
                  Empleado: { $exists: false },
                },
                className: 'Grupos',
              },
            }
          : {
              $inQuery: {
                where: { Empleado: { $exists: false } },
                className: 'Grupos',
              },
            },
      createdAt: filterFrom,
      promotor,
      prestamo_personalizado: { $ne: true },
      factor_cobro: { $exists: true },
      prestamo_personalizado_interes: { $exists: false },
    };

    if (this.state.fintrar_por_fecha_finalizacion) {
      where.fecha_finalizacion = !_.isEmpty(whereFechaPago.where.fecha_pago)
        ? whereFechaPago.where.fecha_pago
        : undefined;
      where.status = 'baja';
    }

    where.Pagos = !_.isEmpty(whereFechaPago.where.fecha_pago)
      ? { $inQuery: whereFechaPago }
      : { $exists: true };

    return where;
  };

  componentDidMount = () => {
    $('#modal-payment-form').on('hide.bs.modal', () => {
      this.setPaymentInfo();
    });
  };

  getXLS = async () => {
    if (!this.state.collection.length) {
      alert('Realice un filtro para descargar el archivo Excel');
      return;
    }

    this.handleSpinner();

    const res = await fetchXLS({
      className: this.className || 'Solicitudes',
      where: this.state.where,
      order: this.order,
      include: this.include,
      type: this.state.filter_type || 'pagos_programados',
      format: 'json',
    });

    const headers = [
      H_INDEX,
      H_GROUP,
      H_PROMOTER,
      H_DISBURSEMENT,
      H_PAYMENT_AMOUNT,
      H_BALANCE,
      H_CURRENT_PAYMENT,
      H_END_DATE,
      H_BRANCH_OFFICE,
    ];

    const transformedData = res.result.map((req) => ({
      [H_INDEX]: req.index,
      [H_GROUP]: req.nombre_grupo,
      [H_PROMOTER]: req.nombre_promotor,
      [H_DISBURSEMENT]: req.monto_desembolsado,
      [H_PAYMENT_AMOUNT]: req.monto_pago,
      [H_BALANCE]: req.saldo,
      [H_CURRENT_PAYMENT]: req.pago_actual,
      [H_END_DATE]: req.fecha_termino,
      [H_BRANCH_OFFICE]: req.sucursal,
    }));

    try {
      const fileName = `Reporte de ${this.title.toLowerCase()}`;
      const sheetName = `Reporte`;

      // Delegar la construcción y guardado del archivo Excel al builder
      buildExcelReport(transformedData, headers, fileName, sheetName, {
        moneyCols: ['D', 'E', 'F'], // Columnas D, E y F para formato de moneda
        sumCols: ['D', 'E', 'F'], // Columnas D, E y F para sumatoria
        useDynamicRange: true,
        onError: () =>
          alert('Ha ocurrido un error al intentar descargar el archivo Excel'),
      });
    } catch (error) {
      alert('Ha ocurrido un error al intentar descargar el archivo Excel');
    } finally {
      this.handleSpinner();
    }
  };

  getPaymentsMade = (_where = {}) => {
    let promise = new Promise(async (resolve, reject) => {
      let requisitions = [];
      let pagado_al = undefined;

      if (!_.isEmpty(_where.Pagos)) {
        try {
          if (!_.isEmpty(_where.Pagos.$inQuery.where.fecha_pago)) {
            pagado_al = _where.Pagos.$inQuery.where.fecha_pago;
            // delete where.Pagos.$inQuery.where.fecha_pago;
          }
        } catch (error) {
          console.log(error);
        }
      }

      let payWhere = JSON.stringify({
        pagado_al: pagado_al,
        Solicitud: {
          $inQuery: {
            where: _where,
            className: 'Solicitudes',
          },
        },
      });

      const query = async (skip = 0) => {
        let params;

        params = new URLSearchParams({
          limit: 1000,
          skip: skip,
          where: payWhere,
          count: 1,
          order: this.order,
          include: this.include,
        });

        return Rest.peticion(
          `${
            config.api_url
          }/classes/SolicitudesPagosRealizados?${params.toString()}`,
          {
            method: 'GET',
          }
        )
          .then((res) => {
            return res.json();
          })
          .then((res) => {
            return res;
          })
          .then(async (res) => {
            requisitions = requisitions.concat(res.results);
            if (res.count === requisitions.length) {
              let total = 0.0;
              for (let index = 0; index < res.results.length; index++) {
                const item = res.results[index];
                total += item.monto_pagado;
              }
              resolve(total);
            } else {
              await query(requisitions.length);
            }
          })
          .catch((error) => {
            reject(0.0);
          });
      };

      await query(0);
    });
    return promise;
  };

  getResource = async (index = 0, _where = {}, search = undefined) => {
    this.handleSpinner();

    let params;

    if (search) {
      params = search;
    } else {
      this.setState({
        index: index,
        loadSumary: null,
        monto_desembolsado_total: 0.0,
        monto_pago_total: 0.0,
        monto_pagado_total: 0.0,
        where: _where,
      });

      params = {
        limit: this.limit,
        skip: index,
        where: _where,
        order: this.order,
        include: this.include,
      };
    }

    try {
      const res = await fetchSolicitudes(params);

      if (res.code) {
        alert('Ha ocurrido un error inesperado. Intente más tarde.');
      } else {
        this.rows = res.count;

        let collection = _.map(res.results, (item, idx) => {
          const montoPago = this.setPay(item);
          const pagos = _.sortBy(item.Pagos, (p) => p.numero_pago);
          const fechaTermino = pagos[pagos.length - 1].fecha_pago.iso;

          return {
            objectId: item.objectId,
            groupId: item.Grupo.objectId,
            index: idx + 1 + parseInt(this.state.index),
            nombre_grupo: item.Grupo.nombre,
            nombre_sucursal: item.Sucursal.nombre,
            ciclo: item.ciclo,
            nombre_promotor: this.setPromotor(item),
            monto_desembolsado: this.setAuthorizedAmount(item),
            monto_pago: montoPago,
            pago_actual: this.setCurrentPatmentNumber(item),
            pagos_totales: this.setNumberPayments(item),
            fecha_termino: textUtils.setLegibleDate(fechaTermino),
            saldo: RequisitionModel.balanceDue(item, montoPago),
            pago_realizado_status: this.setPaymentMade(item, montoPago),
            status: item.status,
          };
        });

        this.collection = _.groupBy(res.results, 'objectId');

        this.handleSpinner();

        this.setState({
          collection: collection,
          total: res.count,
        });
      }

      // Totales
      let totalPaid = 0.0;
      let montoDesembolsadoTotal = 0.0;
      let montoPagoTotal = 0.0;
      let balanceDueTotal = 0.0;

      if (this.state.total > 100) {
        const totals = await fetchBigLotTotals({
          where: _where,
          order: this.order,
          include: this.include,
          setPay: this.setPay,
        });

        totalPaid = totals.totalPaid;
        montoDesembolsadoTotal = totals.total_desembolsos;
        montoPagoTotal = totals.total_montopagos;
        balanceDueTotal = totals.balanceDue_total;
      } else {
        // Pagos realizados
        const pagosWhere = {
          pagado_al: undefined,
          Solicitud: {
            $inQuery: {
              where: _where,
              className: 'Solicitudes',
            },
          },
        };

        const pagosRes = await fetchPagosRealizados({
          where: pagosWhere,
          order: this.order,
          include: this.include,
        });

        totalPaid = _.reduce(
          pagosRes.results,
          (sum, item) => sum + item.monto_pagado,
          0
        );

        montoDesembolsadoTotal = this.setTotalAuthorizedAmount(
          this.state.collection
        );
        montoPagoTotal = this.setTotalWeeklyPayment(this.state.collection);
        balanceDueTotal = this.setbalanceDue_total(this.state.collection);
      }

      this.setState({
        monto_pagado_total: totalPaid,
        monto_desembolsado_total: montoDesembolsadoTotal,
        monto_pago_total: montoPagoTotal,
        balanceDue_total: balanceDueTotal,
      });

      this.setState({ loadSumary: false });
    } catch (error) {
      console.log(error);
      this.handleSpinner();
      alert('Ha ocurrido un error inesperado. Intente más tarde.');
    }
  };

  setPaymentMade = (requisition, montoPago) => {
    return wasPaymentMade(
      requisition,
      montoPago,
      this.state.dateStart,
      this.state.dateEnd
    );
  };

  handleChange = (event) => {
    const { name, type, checked, value } = event.target;
    this.setState({ [name]: type === 'checkbox' ? checked : value });
    return true;
  };

  handleChangeDate = (date, name) => {
    this.setState({ [name]: date });
  };

  setPromotor = getPromotorFullName;
  setNumberPayments = RequisitionModel.setNumberPayments;
  setCurrentPatmentNumber = RequisitionModel.setCurrentPatmentNumber;
  setPay2 = RequisitionModel.setPay2Exacto;
  setPay = (solicitud) => this.setPay2(solicitud);
  setTotalAuthorizedAmount = (collection) =>
    sumCollectionByKey(collection, 'monto_desembolsado');
  setTotalWeeklyPayment = (collection) =>
    sumCollectionByKey(collection, 'monto_pago');
  setbalanceDue_total = sumCollectionBalanceDue;
  setAuthorizedAmount = getTotalAuthorizedAmount;

  setPaymentInfo = (objectId) => {
    this.setState({
      requisitionSelected: objectId ? this.collection[objectId][0] : '',
    });
  };

  handlePrintDocument = () => {
    if (!this.state.collection.length) {
      alert('Sin datos para descargar');
      return;
    }
    this.handleSpinner();
    Rest.peticion(`${config.api_url}/functions/getXLS`, {
      method: 'POST',
      body: JSON.stringify({
        className: this.className || 'Solicitudes',
        where: this.state.where,
        order: this.order,
        include: this.include,
        type: this.state.filter_type || 'pagos_programados',
        format: 'json',
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        const generateData = (collection) =>
          collection.map((item) => ({
            [H_INDEX]: item.index ? String(item.index) : '',
            [H_GROUP]: item.nombre_grupo ? String(item.nombre_grupo) : '',
            [H_PROMOTER]: item.nombre_promotor
              ? String(item.nombre_promotor)
              : '',
            [H_DISBURSEMENT]: formatMoney(item.monto_desembolsado),
            [H_PAYMENT_AMOUNT]: formatMoney(item.monto_pago),
            [H_CURRENT_PAYMENT]: item.pago_actual
              ? String(item.pago_actual)
              : '',
            [H_BALANCE]: formatMoney(item.saldo),
            [H_END_DATE]: item.fecha_termino ? String(item.fecha_termino) : '',
          }));
        const createHeaders = (keys) =>
          keys.map((k) => ({
            id: k,
            name: k,
            prompt: k,
            padding: 0,
          }));
        const headers = createHeaders([
          H_INDEX,
          H_GROUP,
          H_PROMOTER,
          H_DISBURSEMENT,
          H_PAYMENT_AMOUNT,
          H_CURRENT_PAYMENT,
          H_BALANCE,
          H_END_DATE,
        ]);
        const doc = new jsPDF({ orientation: 'landscape' });
        doc.setFontSize(20);
        doc.setTextColor(199, 137, 177);
        doc.text('Pagos', 7, 10);
        doc.setTextColor(0, 0, 0);
        doc.table(7, 15, generateData(res.result), headers, {
          autoSize: true,
          fontSize: 10,
        });
        doc.save('pagos.pdf');
        return true;
      })
      .catch(() => {
        alert('Ha ocurrido un error al intentar descargar el archivo Excel');
      })
      .then(() => {
        this.handleSpinner();
      });
  };

  handleFilter = (event) => {
    if (event) event.preventDefault();
    const {
      dateStart,
      dateEnd,
      nombre,
      Sucursal,
      promotor,
      includeDowns,
      fintrar_por_fecha_finalizacion,
    } = this.state;
    let start = _.isDate(dateStart) ? new Date(dateStart) : undefined;
    if (start) start.setHours(0, 0, 0, 0);
    let end = _.isDate(dateEnd) ? new Date(dateEnd) : undefined;
    if (end) end.setHours(24, 0, 0, 0);
    const name_group = textUtils.setIdBusqueda(nombre);
    let _where = {
      dateStart: start
        ? { __type: 'Date', iso: start.toISOString() }
        : undefined,
      dateEnd: end ? { __type: 'Date', iso: end.toISOString() } : undefined,
      id_busqueda: _.isEmpty(name_group) ? undefined : { $regex: name_group },
      Sucursal: _.isEmpty(Sucursal)
        ? undefined
        : { __type: 'Pointer', className: 'Sucursales', objectId: Sucursal },
      promotor: _.isEmpty(promotor)
        ? undefined
        : { __type: 'Pointer', className: 'Empleados', objectId: promotor },
      includeDowns,
      fintrar_por_fecha_finalizacion,
    };
    const where = this.setWhere(_where);
    this.rows = 0;
    this.getResource(0, where);
  };

  printAccountStatement = (documentName = undefined, _requisition = {}) => {
    this.setState({ requisitionPrint: false, loading: true });
    setTimeout(() => {
      const requisition = this.collection[_requisition.objectId][0];
      this.setState({ requisitionPrint: requisition });
      setTimeout(() => {
        this.setState({ requisitionPrint: requisition, loading: false });
      }, 500);
      localStorage.setItem(
        'account_statement_requisition',
        JSON.stringify(_.clone(requisition))
      );
      localStorage.setItem(
        'pago_total_periodo',
        JSON.stringify(this.setPay2(requisition))
      );
      window.frames[documentName].focus();
      window.frames[documentName].print();
    }, 500);
  };

  render() {
    const { state } = this;
    return (
      <>
        <Spinner loading={state.loading} />
        <h3 className="text-uppercase text-pink pt-3 pb-3">
          <i className="fas fa-money-bill-wave mr-2"></i>
          {this.title}
        </h3>
        <div className="card">
          <div className="card-body">
            <GroupListPaymentFilter
              handleChange={this.handleChange}
              handleChangeDate={this.handleChangeDate}
              handleFilter={this.handleFilter}
              state={state}
              inputGroupEnabled={!user.rol.permisos.Pagos.filtro_nombre}
              inputDateEnabled={!user.rol.permisos.Pagos.filtro_fecha}
              inputSucursalEnabled={!user.rol.permisos.Pagos.filtro_fecha}
              inputPrometerEnabled={!user.rol.permisos.Pagos.filtro_promotor}
              inputincludeDownsEnabled={false}
            />

            <div className="text-right">
              <div className="btn-group" role="group" aria-label="Descargas">
                {user.rol.permisos.Pagos.descargar_excel === true && (
                  <button
                    className="btn btn-secondary"
                    onClick={() => this.getXLS()}
                  >
                    Descargar Excel
                  </button>
                )}
                {user.rol.permisos.Pagos.descargar_pdf === true && (
                  <button
                    className="btn btn-secondary"
                    onClick={() => this.handlePrintDocument()}
                  >
                    Descargar PDF
                  </button>
                )}
              </div>
            </div>

            <TableCountInfo total={state.total} />

            <div
              id="table-pdf"
              className={`${window.innerWidth > 768 && 'table-responsive'}`}
              ref={this.ref}
            >
              {(window.innerWidth > 768 && (
                <>
                  {(state.collection.length > 0 && (
                    <table className="table">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Grupo</th>
                          <th>Ciclo</th>
                          {!(
                            user.rol.permisos.filtros &&
                            user.rol.permisos.filtros.es_promotor === true
                          ) && <th>Promotor</th>}
                          <th className="text-right">Monto desem.</th>
                          <th className="text-right">
                            <span className="no-show-pdf">
                              <Popover
                                title="Monto de pago"
                                content="Es el pago semanal o catorcenal según sea el caso."
                              />
                            </span>
                            Monto pago
                          </th>
                          <th>Pago actual</th>
                          {(user.rol.nombre === 'Administrador' ||
                            user.rol.nombre === 'Contador') && (
                            <th className="text-right">Saldo</th>
                          )}
                          <th>Fecha de término</th>
                          <th className="no-show-pdf"></th>
                        </tr>
                      </thead>
                      <tbody>
                        {state.collection.map((item, index) => (
                          <tr
                            key={index}
                            id={`solicitud-${item.objectId}`}
                            id-grupo={item.groupId}
                            className={
                              item.pago_realizado_status ? 'table-success' : ''
                            }
                          >
                            <td>{item.index}</td>
                            <td className="td-responsive-text">
                              {item.nombre_grupo}
                            </td>
                            <td className="td-responsive-text">{item.ciclo}</td>
                            {!(
                              user.rol.permisos.filtros &&
                              user.rol.permisos.filtros.es_promotor === true
                            ) && (
                              <td className="td-responsive-text">
                                {item.nombre_promotor}
                              </td>
                            )}
                            <td
                              className="text-right"
                              style={{ whiteSpace: 'nowrap' }}
                            >
                              {formatMoney(item.monto_desembolsado)}
                            </td>
                            <td
                              className="text-right"
                              style={{ whiteSpace: 'nowrap' }}
                            >
                              {item.pago_realizado_status && (
                                <sup>
                                  <Popover
                                    title="Pago efectuado"
                                    size="normal"
                                    className="text-success"
                                    content="De acuerdo a la fecha del filtro, el pago ya fue realizado."
                                  />
                                </sup>
                              )}
                              {formatMoney(item.monto_pago)}
                            </td>
                            <td>
                              {!_.isUndefined(item.pago_actual) &&
                                !_.isUndefined(item.pagos_totales) &&
                                `${item.pago_actual}/${item.pagos_totales}`}
                            </td>
                            {(user.rol.nombre === 'Administrador' ||
                              user.rol.nombre === 'Contador') && (
                              <td className="text-right">
                                {formatMoney(item.saldo)}
                              </td>
                            )}
                            <td>{item.fecha_termino}</td>
                            <td
                              className="p-2 text-right no-show-pdf"
                              style={{ whiteSpace: 'nowrap' }}
                            >
                              {!_.isEmpty(user.rol.permisos.Pagos) &&
                                user.rol.permisos.Pagos.consultar && (
                                  <NavLink
                                    to={`/pagos/detalles-del-credito/${item.objectId}`}
                                    className="btn btn-link btn-lg"
                                    target="_blank"
                                  >
                                    <i className="fas fa-chevron-right"></i>
                                  </NavLink>
                                )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                      <tfoot>
                        <tr>
                          <td
                            colSpan={`${
                              user.rol.permisos.filtros &&
                              user.rol.permisos.filtros.es_promotor === true
                                ? 3
                                : 4
                            }`}
                          />
                          <td className="text-right">
                            {(this.state.loadSumary === null && (
                              <SyncLoader
                                size={8}
                                color={'#23A1D3'}
                                loading={true}
                              />
                            )) ||
                              formatMoney(this.state.monto_desembolsado_total)}
                          </td>
                          <td className="text-right">
                            {(this.state.loadSumary === null && (
                              <SyncLoader
                                size={8}
                                color={'#23A1D3'}
                                loading={true}
                              />
                            )) ||
                              formatMoney(this.state.monto_pago_total)}
                          </td>
                          <td></td>
                          {((user.rol.nombre === 'Administrador' ||
                            user.rol.nombre === 'Contador') && (
                            <>
                              <td className="text-right">
                                {(this.state.loadSumary === null && (
                                  <SyncLoader
                                    size={8}
                                    color={'#23A1D3'}
                                    loading={true}
                                  />
                                )) ||
                                  formatMoney(this.state.balanceDue_total)}
                              </td>
                              <td colSpan="2" />
                            </>
                          )) || <td colSpan="3" />}
                        </tr>
                        <tr>
                          <td
                            className="border-top-0"
                            colSpan={`${
                              user.rol.permisos.filtros &&
                              user.rol.permisos.filtros.es_promotor === true
                                ? 3
                                : 4
                            }`}
                          />
                          <td
                            className="text-success text-right text-uppercase"
                            style={{ whiteSpace: 'nowrap' }}
                          >
                            Total pagado
                          </td>
                          <td className="text-success text-right">
                            {(this.state.loadSumary === null && (
                              <SyncLoader
                                size={8}
                                color={'#23A1D3'}
                                loading={true}
                              />
                            )) ||
                              formatMoney(this.state.monto_pagado_total)}
                          </td>
                        </tr>
                        <tr>
                          <td
                            className="border-top-0"
                            colSpan={`${
                              user.rol.permisos.filtros &&
                              user.rol.permisos.filtros.es_promotor === true
                                ? 3
                                : 4
                            }`}
                          />
                          <td
                            className={`text-right text-uppercase ${
                              this.state.monto_pagado_total -
                                this.state.monto_pago_total <
                              0
                                ? 'text-danger'
                                : 'text-info'
                            }`}
                          >
                            Saldo (+/-)
                          </td>
                          <td
                            className={`text-right ${
                              this.state.monto_pagado_total -
                                this.state.monto_pago_total <
                              0
                                ? 'text-danger'
                                : 'text-info'
                            }`}
                          >
                            {(this.state.loadSumary === null && (
                              <SyncLoader
                                size={9}
                                color={'#23A1D3'}
                                loading={true}
                              />
                            )) ||
                              formatMoney(
                                this.state.monto_pagado_total -
                                  this.state.monto_pago_total
                              )}
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  )) || (
                    <div className="text-center">
                      <div
                        className="alert alert-warning m-0 mt-3 mb-3"
                        role="alert"
                      >
                        <i className="fas fa-filter"></i> Realice un filtro
                      </div>
                    </div>
                  )}
                </>
              )) || (
                <>
                  <br />
                  {(state.collection.length > 0 && (
                    <>
                      {state.collection.map((item, index) => (
                        <div key={index} className="position-relative">
                          <span
                            className="badge badge-secondary list-partner-item-counter ml-4"
                            style={{ zIndex: 1 }}
                          >
                            {item.index}
                          </span>
                          <div
                            key={index}
                            className="card mb-4 mt-3 shadow"
                            style={{ overflow: 'hidden' }}
                          >
                            <div
                              className={`card-body ${
                                item.pago_realizado_status === false &&
                                'bg-light'
                              }`}
                              style={
                                (item.pago_realizado_status && {
                                  backgroundColor: '#83cd93',
                                }) ||
                                {}
                              }
                            >
                              <div className="p-1 container">
                                <div className="row">
                                  <div className="col">
                                    <span
                                      className=""
                                      style={{ color: 'rgba(0,0,0,0.6)' }}
                                    >
                                      Grupo:
                                    </span>
                                    <h5 className="font-weight-bold text-primary">
                                      {item.nombre_grupo}
                                    </h5>
                                  </div>
                                  <div className="col-5 text-right">
                                    <span
                                      className=""
                                      style={{ color: 'rgba(0,0,0,0.6)' }}
                                    >
                                      Ciclo:
                                    </span>{' '}
                                    <b>{item.ciclo}</b>
                                  </div>
                                </div>
                              </div>
                              {!(
                                user.rol.permisos.filtros &&
                                user.rol.permisos.filtros.es_promotor === true
                              ) && (
                                <table className="table table-borderless m-0">
                                  <tbody>
                                    <tr>
                                      <td
                                        colSpan="2"
                                        className="p-1 "
                                        style={{ color: 'rgba(0,0,0,0.6)' }}
                                      >
                                        Promotor:
                                      </td>
                                      <th
                                        colSpan="2"
                                        className="p-1 text-right"
                                      >
                                        {item.nombre_promotor}
                                      </th>
                                    </tr>
                                  </tbody>
                                </table>
                              )}
                              <table className="table table-borderless">
                                <tbody>
                                  <tr>
                                    <td
                                      className="p-1 "
                                      style={{ color: 'rgba(0,0,0,0.6)' }}
                                    >
                                      Monto desembolsado:
                                    </td>
                                    <th className="p-1 text-right">
                                      {formatMoney(item.monto_desembolsado)}
                                    </th>
                                  </tr>
                                  <tr>
                                    <td
                                      className="p-1 "
                                      style={{ color: 'rgba(0,0,0,0.6)' }}
                                    >
                                      Monto pago:
                                    </td>
                                    <th className="p-1 text-right">
                                      {item.pago_realizado_status && (
                                        <sup>
                                          <Popover
                                            title="Pago efectuado"
                                            size="normal"
                                            className="text-success"
                                            content="De acuerdo a la fecha del filtro, el pago ya fue realizado."
                                          />
                                        </sup>
                                      )}
                                      {formatMoney(item.monto_pago)}
                                    </th>
                                  </tr>
                                  <tr>
                                    <td
                                      className="p-1 "
                                      style={{ color: 'rgba(0,0,0,0.6)' }}
                                    >
                                      Pago actual:
                                    </td>
                                    <th className="p-1 text-right">
                                      {!_.isUndefined(item.pago_actual) &&
                                        !_.isUndefined(item.pagos_totales) &&
                                        `${item.pago_actual}/${item.pagos_totales}`}
                                    </th>
                                  </tr>
                                  <tr>
                                    <td
                                      className="p-1 "
                                      style={{ color: 'rgba(0,0,0,0.6)' }}
                                    >
                                      Fecha de término:
                                    </td>
                                    <th className="p-1 text-right">
                                      {item.fecha_termino}
                                    </th>
                                  </tr>
                                  {(user.rol.nombre === 'Administrador' ||
                                    user.rol.nombre === 'Contador') && (
                                    <tr>
                                      <td
                                        className="p-1 "
                                        style={{ color: 'rgba(0,0,0,0.6)' }}
                                      >
                                        Saldo:
                                      </td>
                                      <th className="p-1 text-right text-primary">
                                        {formatMoney(item.saldo)}
                                      </th>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                              <div className="btn-group btn-block" role="group">
                                {!_.isEmpty(user.rol.permisos.Pagos) &&
                                  user.rol.permisos.Pagos.consultar && (
                                    <NavLink
                                      to={`/pagos/detalles-del-credito/${item.objectId}`}
                                      className="btn btn-primary"
                                    >
                                      Ver detalles{' '}
                                      <i className="fas fa-chevron-right"></i>
                                    </NavLink>
                                  )}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                      <div className="card mb-3">
                        <div className="card-body">
                          <h5>
                            <b>Totales</b>
                          </h5>
                          <table className="table table-borderless m-0">
                            <tbody>
                              <tr>
                                <td className=" pl-0 ">Monto desembolsado</td>
                                <td className="text-right pr-0">
                                  {(this.state.loadSumary === null && (
                                    <SyncLoader
                                      size={8}
                                      color={'#23A1D3'}
                                      loading={true}
                                    />
                                  )) ||
                                    formatMoney(
                                      this.state.monto_desembolsado_total
                                    )}
                                </td>
                              </tr>
                              <tr>
                                <td className=" pl-0 ">Monto pago</td>
                                <td className="text-right pr-0">
                                  {(this.state.loadSumary === null && (
                                    <SyncLoader
                                      size={8}
                                      color={'#23A1D3'}
                                      loading={true}
                                    />
                                  )) ||
                                    formatMoney(this.state.monto_pago_total)}
                                </td>
                              </tr>
                              <tr>
                                <td
                                  className="text-success pl-0 "
                                  style={{ whiteSpace: 'nowrap' }}
                                >
                                  Total pagado
                                </td>
                                <td className="text-success text-right pr-0">
                                  {(this.state.loadSumary === null && (
                                    <SyncLoader
                                      size={8}
                                      color={'#23A1D3'}
                                      loading={true}
                                    />
                                  )) ||
                                    formatMoney(this.state.monto_pagado_total)}
                                </td>
                              </tr>
                              <tr>
                                <td
                                  className={` pl-0 ${
                                    this.state.monto_pagado_total -
                                      this.state.monto_pago_total <
                                    0
                                      ? 'text-danger'
                                      : 'text-info'
                                  }`}
                                >
                                  Saldo (+/-)
                                </td>
                                <td
                                  className={`text-right pr-0 ${
                                    this.state.monto_pagado_total -
                                      this.state.monto_pago_total <
                                    0
                                      ? 'text-danger'
                                      : 'text-info'
                                  }`}
                                >
                                  {(this.state.loadSumary === null && (
                                    <SyncLoader
                                      size={9}
                                      color={'#23A1D3'}
                                      loading={true}
                                    />
                                  )) ||
                                    formatMoney(
                                      this.state.monto_pagado_total -
                                        this.state.monto_pago_total
                                    )}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </>
                  )) || (
                    <div className="text-center">
                      <div
                        className="alert alert-warning m-0 mt-3 mb-3"
                        role="alert"
                      >
                        <i className="fas fa-filter"></i> Realice un filtro
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>

            <div className="row align-items-center">
              <div className="col-md-6">
                <TableCountInfo total={this.state.total} />
              </div>
              <div className="col-md-6">
                <TablePagination
                  index={this.state.index}
                  align="end"
                  limit={this.limit}
                  rows={this.rows}
                  getData={this.getResource}
                  where={this.state.where}
                />
              </div>
            </div>
          </div>

          <GroupPaymentForm
            id="modal-payment-form"
            requisition={state.requisitionSelected}
            handleFilter={this.handleFilter}
            pago_total_periodo={this.setPay2(state.requisitionSelected)}
            setPaymentInfo={this.setPaymentInfo}
            include={this.include}
          />

          {!_.isEmpty(state.requisitionPrint) && (
            // eslint-disable-next-line jsx-a11y/iframe-has-title
            <iframe
              id="estado-cuenta"
              name="estado-cuenta"
              width="0"
              height="0"
              src={`${this.props.match.url}/estado-cuenta?no_margin=true&is_print=true`}
            ></iframe>
          )}
        </div>
      </>
    );
  }
}

export default GroupListPayment;
